import React, {SyntheticEvent, useCallback, useMemo, useState} from 'react';
import {
  Box, Button,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip
} from "@material-ui/core";
import {KeyboardDatePicker} from "@material-ui/pickers";
import {DateTime} from "luxon";
import {FiltersRow} from "../../../pages/root/transaction/components";
import {useBoolean} from "../../../hooks/utils/useBoolean";
import FilterList from "@material-ui/icons/FilterList";

export interface DateRangeFilterProps {
  fullWidth?: boolean
  start?: DateTime
  finish?: DateTime
  onChange: (start: DateTime, finish: DateTime) => void
}

export const DateRangeFilter = (p: DateRangeFilterProps) => {
  const [open, on, off] = useBoolean(),
    [start, setStart] = useState(p.start || DateTime.local()),
    [finish, setFinish] = useState(p.finish || DateTime.local())

  const onSubmit = useCallback((e: SyntheticEvent<{}>) => {
    e.preventDefault()
    p.onChange(start, finish)
    off()
  }, [finish, off, p, start])

  const value = useMemo(() => {
    return start.toFormat('yyyy-LL-dd')+' to '+finish.toFormat('yyyy-LL-dd')
  },[finish, start])

  return (
    <>
      <TextField
        fullWidth={p.fullWidth}
        value={value}
        disabled
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <Tooltip title='Filter by date range'>
                <IconButton onClick={on} size='small'>
                  <FilterList />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          )
        }}
      />
      <Dialog open={open} onClose={off}>
        <form onSubmit={onSubmit}>
          <DialogTitle>Filter Date range</DialogTitle>
          <DialogContent>
            <FiltersRow>
              <Box flexGrow={1}>
                <KeyboardDatePicker
                  disableToolbar
                  fullWidth
                  variant="inline"
                  format="yyyy.LL.dd"
                  margin="normal"
                  label="Select start date range"
                  value={start}
                  onChange={(d) =>
                    d && setStart(DateTime.fromMillis(d.toMillis()))
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Box>
              <Box flexGrow={1}>
                <KeyboardDatePicker
                  disableToolbar
                  fullWidth
                  variant="inline"
                  format="yyyy.LL.dd"
                  margin="normal"
                  label="Select finish date range"
                  value={finish}
                  onChange={(d) =>
                    d && setFinish(DateTime.fromMillis(d.toMillis()))
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Box>
            </FiltersRow>
          </DialogContent>
          <DialogActions>
            <Button type='submit' color='primary'>Filter</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export const SingleDateFilter = (p: DateRangeFilterProps) => {
  const [open, on, off] = useBoolean(),
    [start, setStart] = useState(p.start || DateTime.local())

  const onSubmit = useCallback((e: SyntheticEvent<{}>) => {
    e.preventDefault()
    p.onChange(start, start)
    off()
  }, [off, p, start])


  const value = useMemo(() => {
    return start.toFormat('yyyy-LL-dd')
  },[start])

  return (
    <>
      <TextField
        fullWidth={p.fullWidth}
        value={value}
        disabled
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <Tooltip title='Filter by date range'>
                <IconButton onClick={on} size='small'>
                  <FilterList />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          )
        }}
      />
      <Dialog open={open} onClose={off}>
        <form onSubmit={onSubmit}>
          <DialogTitle>Choose Date</DialogTitle>
          <DialogContent>
            <FiltersRow>
              <Box flexGrow={1}>
                <KeyboardDatePicker
                  disableToolbar
                  fullWidth
                  variant="inline"
                  format="yyyy.LL.dd"
                  margin="normal"
                  label="Select date"
                  value={start}
                  onChange={(d) =>
                    d && setStart(DateTime.fromMillis(d.toMillis()))
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Box>
            </FiltersRow>
          </DialogContent>
          <DialogActions>
            <Button type='submit' color='primary'>Filter</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
